import { render, staticRenderFns } from "./VueEditor.vue?vue&type=template&id=4d1978b3&"
import script from "./VueEditor.vue?vue&type=script&lang=js&"
export * from "./VueEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports